var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.8,29.4c-9.1,0-17.1,6.5-19,15.3c-0.1,0.3-0.2,0.6-0.3,1c-0.4,1-1.3,1.6-2.1,1.3c-1.1-0.3-1.7-1.2-1.5-2.3 c0.3-1.6,0.8-3.1,1.4-4.5c2.5-6.1,6.9-10.3,13-12.9C16,27,16,27,15.4,26.5c-2.6-2.1-4.4-4.6-5.2-7.9c-2-8.1,3.3-16.2,11.5-17.5 C29.3-0.1,36.5,5,37.8,12.5c1,5.7-0.8,10.4-5.3,14c-0.5,0.4-0.3,0.5,0.1,0.7c3.1,1.3,5.8,3.1,8.2,5.5c3,3,4.9,6.6,5.9,10.7 c0.1,0.3,0.2,0.6,0.2,1c0.4,1.4-0.5,2.3-1.4,2.6c-0.9,0.3-1.8-0.3-2.2-1.4c-0.5-1.3-0.7-2.6-1.3-3.9c-2.6-6.4-7.3-10.2-13.9-11.7 c-0.6-0.1-1.1-0.3-1.7-0.3C25.5,29.5,24.6,29.3,23.8,29.4z M13.6,15.1c0,5.8,4.5,10.4,10.2,10.5c5.8,0.1,10.5-4.6,10.5-10.4 c0-5.8-4.6-10.4-10.4-10.5C18.2,4.7,13.6,9.4,13.6,15.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.3d9c20f8deadebaf62d221be314ac453.svg";
export { ForwardRef as ReactComponent };